import { Component, EventEmitter, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from '../../services/apiservices.service';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Output() ritualPraxisClick = new EventEmitter<void>();

  classToggled = false;
  activemenu: string = '';
  textLoader = false;

  cookieData: any = {};
  login_user_details: any = {};
  userName: string = '';
  lastLogin: string = '';
  cart_Count = 0;

  uiUrl = environment.ui_url;

  /** current ritual-result param (if present in URL) */
  paramId = '';

  constructor(
    public router: Router,
    private apiService: ApiservicesService,
    public activateRoute: ActivatedRoute,
    private cookieService: CookieService,
    public matSnackBar: MatSnackBar
  ) {
    window.scroll(0, 0);
  }

  ngOnInit(): void {
    // cookies / user info
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    if (this.cookieService.getAll()['login_user_details']) {
      this.cookieData = JSON.parse(this.cookieService.getAll()['login_user_details']);
      this.userName  = this.cookieData.userinfo?.name ?? '';
      this.lastLogin = this.cookieData.userinfo?.last_login_time ?? '';
    }

    // keep paramId in sync with current route (works from any depth)
    this.paramId = this.findDeepParam(this.activateRoute, '_id') ?? '';
    this.router.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.paramId = this.findDeepParam(this.activateRoute, '_id') ?? '';
      });

    if (this.router.url.includes('dashboard')) this.activemenu = 'dashboard';

    // example: load cart count for customers
    if (this.cookieData.userinfo?.user_type === 'is_customer') {
      const obj = { id: this.login_user_details.userinfo._id };
      this.apiService.getHttpDataPost('cart/cart_data_count', obj)
        .subscribe({
          next: v => this.cart_Count = v?.count ?? 0,
          error: () => {}
        });
    }
  }

  /** Walks down the activated route tree and returns the first param found */
  private findDeepParam(route: ActivatedRoute, key: string): string | null {
    let r: ActivatedRoute | null = route;
    while (r) {
      const v = r.snapshot.paramMap.get(key);
      if (v) return v;
      r = r.firstChild!;
    }
    return null;
  }

  /** True if we are on /perennial-mandalism-dashboard/ritual-result/:_id */
  get isCreateRitualActive(): boolean {
    return this.router.url.startsWith('/perennial-mandalism-dashboard/ritual-result/');
  }

  toggleNav() { this.classToggled = !this.classToggled; }

  navigateToPath(path: string) { this.router.navigateByUrl(path); }

  currentPath(): string { return this.router.url; }

  backtoHome() {
    window.location.href = `https://divineinfinitebeing.com/`;
  }

  dashboardPage() {
    const t = this.login_user_details.userinfo?.user_type;
    if (t === 'is_admin') this.router.navigateByUrl(`/admin-dashboard`);
    else if (t === 'is_astrologer' || t === 'is_tarotreader') this.router.navigateByUrl(`/astrologer-dashboard`);
    else if (t === 'is_social_advo' || t === 'is_customer') this.router.navigateByUrl(`/customer-dashboard`);
    else if (t === 'is_Perennial_Mandalism' || this.login_user_details.userinfo?.is_perennial_mandalism == 1)
      this.router.navigateByUrl(`/perennial-mandalism-dashboard`);
    else if (t === 'is_affiliate') this.router.navigateByUrl('/affiate-dashboard');
  }

  logout() {
    this.apiService.getHttpData(`user/logout/${this.cookieData.userinfo.username}`)
      .subscribe({
        next: (response) => {
          this.cookieService.delete('login_user_details', '/');
          this.cookieService.delete('loggedin_user', '/');
          this.matSnackBar.open(response.message, 'Ok', { duration: 4000 });
          this.router.navigateByUrl('/');
        },
        error: () => {}
      });
  }

  changePass() { this.router.navigateByUrl(`/change-password`); }

  myAccount() {
    this.router.navigateByUrl(`/my-account/account-info/${this.cookieData.userinfo._id}`);
  }
}
